// extracted by mini-css-extract-plugin
module.exports =  {"main":"Tabs-module_main_f13f6"};